<div class="cta-bar" [class.stack]="stack()">
  @if (challenge.matchmakerApprovalPending()) {
    <div class="inline-overlay pending-overlay">
      <span class="spinner"></span>
      <span class="overlay-text">Approve wallet transaction...</span>
    </div>
  } @else if (challenge.needsMatchmakerApproval()) {
    <div class="inline-overlay">
      <button class="approve-matchmakers-btn" (click)="challenge.triggerMatchmakerApproval()">
        Approve Matchmakers
      </button>
    </div>
  }
  <app-format-segment
    class="fmt"
    [value]="challenge.battleMode()"
    (valueChange)="challenge.battleMode.set($event)"
  />
  <button
    class="challenge-btn cpu-btn"
    [class.loading]="hasTeam() === undefined"
    [disabled]="challengePending() || !challenge.canStartCpuBattle()"
    (click)="cpuBattle.emit()"
  >
    Battle CPU
  </button>
  <button
    (click)="pvpButton.activate()"
    class="challenge-btn"
    [class.loading]="hasTeam() === undefined"
    [class.pending]="challenge.isInQueue()"
    [disabled]="pvpButton.disabled()"
  >
    <!-- @switch recreates the label node, which is what triggers btn-label-morph;
         the strings come from the shared queue state so they can't drift. -->
    @switch (pvpButton.label()) {
      @case ('join') {
        <span class="btn-label">{{ pvpButton.text() }}</span>
      }
      @default {
        <span class="btn-label"><span class="spinner"></span> {{ pvpButton.text() }}</span>
      }
    }
  </button>
  <button
    class="challenge-btn custom-btn"
    [class.hidden]="challenge.battleMode() === 0"
    [disabled]="challengePending() || !hasTeam()"
    (click)="customGame.emit()"
  >
    Custom Game
  </button>
</div>
